import { withRequiredProps } from 'hoc';
import { useSafeFieldValues } from 'hooks';
import type { DigizuiteAsset } from 'models/asset';
import type {
	Column,
	Field,
	FooterLinkField,
	IconLinkField,
	ImageColumn,
	SitecoreBlockProps,
} from 'models/sitecore';
import type { HTMLString, TemplateString } from 'types';

import PageFooter from './PageFooter';

interface Props extends SitecoreBlockProps {
	fields: {
		columns: Column[];
		companyName?: Field<string>;
		followUsLabel?: Field<TemplateString>;
		heading?: Field<string>;
		imageColumns: ImageColumn[];
		secondaryLinks: FooterLinkField[];
		socialMedia: IconLinkField[];
		svgImages: {
			value: {
				assets: DigizuiteAsset[];
			};
		};
		text?: Field<HTMLString>;
		triggerbeeCampaignId?: Field<string>;
	};
}

function PageFooterBlock({ fields }: Props) {
	const texts = useSafeFieldValues(fields);
	const triggerbeeId = fields.triggerbeeCampaignId?.value;

	return (
		<>
			{triggerbeeId && <div id={triggerbeeId} />}
			<PageFooter
				// These classes could just as well live in the PageFooter component
				// itself, but putting it here makes the Storybook experience better.
				className="sticky top-[100vh] mt-14 md:mt-20"
				companyName={texts.companyName}
				followUsLabel={texts.followUsLabel}
				heading={texts.heading}
				menuColumns={fields.columns}
				imageColumns={fields.imageColumns}
				infoText={fields.text?.value}
				secondaryLinks={fields.secondaryLinks}
				socialMediaLinks={fields.socialMedia}
			/>
		</>
	);
}
PageFooterBlock.displayName = 'PageFooterBlock';

export default withRequiredProps(PageFooterBlock, 'fields');
